import directionMap from "./directionMap.component";

const directionMapModule = angular
  .module("app.components.directionMap", [])
  .component("directionMap", directionMap);

export default directionMapModule;



// WEBPACK FOOTER //
// ./src/components/directionMap/directionMap.module.js